var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 77,
    viewBox: "0 0 58 77",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.22 71.58H18.1401C8.68014 71.58 1 63.91 1 54.44V18.14C1 8.68 8.67014 1 18.1401 1H27.22C36.68 1 44.3601 8.67 44.3601 18.14V45.5",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 42.25H44.3601",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21021 21.63V26.05",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21021 28.53V32.95",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21021 35.43V39.85",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6301 21.63V26.05",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6301 28.53V32.95",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6301 35.43V39.85",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.05 21.63V26.05",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.05 28.53V32.95",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.05 35.43V39.85",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.48 21.63V26.05",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.48 28.53V32.95",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.48 35.43V39.85",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9001 21.63V26.05",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9001 28.53V32.95",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9001 35.43V39.85",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3301 21.63V26.05",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3301 28.53V32.95",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3301 35.43V39.85",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 21.63V26.05",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 28.53V32.95",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 35.43V39.85",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4402 61.72H10.9001V51.35H28.04",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9001 75.67C50.4112 75.67 56.5 69.5811 56.5 62.07C56.5 54.5589 50.4112 48.47 42.9001 48.47C35.3891 48.47 29.3 54.5589 29.3 62.07C29.3 69.5811 35.3891 75.67 42.9001 75.67Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0901 71.09C44.0401 71.4 46.64 70.78 47.98 68.68C49.57 66.18 48.29 63.28 48.28 63.27C48.28 63.26 48.27 63.24 48.27 63.24C48.27 63.23 48.26 63.22 48.25 63.2C47.79 62.35 47.5202 60.91 48.4202 58.38C47.4102 58.69 46.27 59.26 45.73 60.35C45.43 60.95 45.4202 61.5 45.1802 61.53C44.7702 61.58 44.1501 60.14 43.8701 58.75C43.3401 56.16 43.9502 53.53 43.9502 53.53C39.3002 55.44 41.1101 60.64 41.1101 60.64C41.4801 62.64 40.5802 63.6 39.6602 63.49C38.2902 63.33 38.3301 60.11 38.3301 60.11C37.9001 60.63 36.5902 62.32 36.6602 64.68C36.7502 67.63 38.9701 70.6 42.0901 71.09Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.53 58.23C16.4689 58.23 17.23 57.4689 17.23 56.53C17.23 55.5911 16.4689 54.83 15.53 54.83C14.5911 54.83 13.8301 55.5911 13.8301 56.53C13.8301 57.4689 14.5911 58.23 15.53 58.23Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6001 16.35C16.3063 16.35 18.5 14.1562 18.5 11.45C18.5 8.74381 16.3063 6.55 13.6001 6.55C10.8939 6.55 8.7002 8.74381 8.7002 11.45C8.7002 14.1562 10.8939 16.35 13.6001 16.35Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.28 12.58L15.6101 9.03999",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/gas.89d53fa04ec7173d2dc975f4107a26e9.svg";
export { ForwardRef as ReactComponent };